import type { ViewDto } from 'cadenza/workbook/api/view-dto';
import { MapViewSettingsKey } from 'cadenza/workbook/model/map-view-settings-key.gen';
import { getSetting } from 'cadenza/workbook/workbook-settings-util';

export function is3DMapView(viewDto: ViewDto) {
  return getSetting<boolean>(viewDto, MapViewSettingsKey.toPersistenceKey('TIMELINE_3D_ENABLED'), false);
}
